import m from 'mithril'
import stream from 'mithril/stream'
import {
    Dialog,
} from 'components'

export default class EditDialog {
    constructor(vnode) {
        this.answer = vnode.attrs.answer
        this.model = vnode.attrs.model
        this.selectIndex = vnode.attrs.selectIndex
        this.orders = ['A', 'B', 'C', 'D']
    }
    close(event) {
        this._close()
    }
    _close(value) {
        setTimeout(() => {
            Dialog.close(value)
            m.redraw()
        }, 200)
    }
    oninit(state) {
        const audio = document.createElement("audio");
        if (this.answer) {
            audio.src = "./mp3/correct.mp3";
            setTimeout(() => {
                audio.play();
            }, 50)
        } else {
            audio.src = "./mp3/wrong.mp3";
            audio.play();
        }
        // setTimeout(() => {
        //     audio.play();
        // }, 50)
    }

    view() {
        const selectedItem = this.model.items[this.selectIndex];
        const selectedText = (typeof selectedItem === 'string') ? selectedItem : (selectedItem.text || selectedItem);
        const selectedAnalysis = this.model.analysis || ((typeof selectedItem === 'string') ? '（此為舊版題目，無解析）' : (selectedItem.analysis || '解析資料載入中...'));

        return [m(".modal-dialog.modal-dialog-centered.modal-xl", [
            m('.modal-content', [
                m('.modal-body', [
                    m(".row.no-gutters.d-flex.align-items-start.justify-content-center", [
                        m(".col-9.py-2.d-flex", [
                            m("img.img-fluid", {
                                src: (this.answer) ? `./img/01.png` : `./img/02.png`,
                                style: {
                                    maxWidth: "180px",
                                    // maxHeight: "80px"
                                }
                            }),
                 
                            m(".row.no-gutters.d-flex.justify-content-start.align-items-bottom.ps-4", [
                                m(".col-12.d-flex.align-items-end", [
                                    m("span.font-weight-bold", {
                                        style: {
                                            color: (this.answer) ? this.model.color : "#E36642",
                                            fontSize: "3.5rem",
                                            fontWeight: 700
                                        }
                                    }, (this.answer) ? '恭喜答對囉！' : "答案錯了喔！"),
                                ]),
                                m(".col-12.pt-3", [
                                    (this.answer) ? m(".d-inline.mb-0", {
                                        style: {
                                            background: this.model.color,
                                            padding: "10px 20px"
                                        }
                                    }, [
                                        m("span.font-weight-bold", {
                                            style: {
                                                color: "#FFFFFF",
                                                fontSize: "1.2rem"
                                            }
                                        }, "正確答案解析")
                                    ]) : m(".d-inline.mb-0", {
                                        style: {
                                            background: "#E36642",
                                            padding: "10px 20px"
                                        }
                                    }, [
                                        m("span.font-weight-bold", {
                                            style: {
                                                color: "#FFFFFF",
                                                fontSize: "1.2rem"
                                            }
                                        }, "錯誤內容解析")
                                    ]),
                                ]),
                            ]),
                        ]),
                        m(".col-2.d-flex.align-items-center.justify-content-center.pt-5", [
                            m(".d-flex.align-items-center.justify-content-center", {
                                style: {
                                    background: "#FFFFFF",
                                    color: this.model.color,
                                    border: "1px " + this.model.color + " solid",
                                    borderRadius: "30px",
                                    height: "65px",
                                    cursor: "pointer",
                                    width: "200px"
                                },
                                onclick: (e) => {
                                    e.preventDefault()
                                    this.close(true)
                                }
                            }, [
                                m("span.font-weight-bold.px-2", { style: { fontSize: "2rem", fontWeight: 700 } }, "回列表")
                            ])
                        ]),
                        m(".col-12.py-3.px-5", [
                            m("p.ml-3.mt-2", {
                                style: {
                                    color: "#464646",
                                    fontWeight: 600,
                                    fontSize: "1.4rem",
                                    lineHeight: "1.8",
                                    whiteSpace: "pre-wrap",
                                    textAlign: "justify"

                                }
                            }, selectedAnalysis)
                        ]),
                        
                    ])
                ]),

            ])
        ])]
    }
}
